/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC} from 'react'

const Footer: FC = () => {
  return (
    <div
      id='kt_footer'
      style={{
        padding: '14px 24px',
        borderTop: '1px solid rgba(255,255,255,0.04)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <span style={{color: '#334155', fontSize: '12px', fontWeight: 500}}>
        © {new Date().getFullYear()} BottomUP. All rights reserved.
      </span>
    </div>
  )
}

export {Footer}
